"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedPropTypes = exports.layoutConstants = exports.PersonalDetailsAvatarDefaultProps = exports.PHONE_TOOL_URL = exports.INVERTED_COLOR_SCHEME = exports.DEFAULT_COLOR_SCHEME = exports.BADGE_PHOTO_URL = exports.AvatarDefaultProps = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var _layoutConstants;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var layoutConstants = (_layoutConstants = {}, (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.ExtraSmall, {
  imageSize: 24,
  imageSpacing: 8,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 0,
  maxChildren: 0
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Small, {
  imageSize: 32,
  imageSpacing: 8,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 4,
  maxChildren: 1
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Medium, {
  imageSize: 48,
  imageSpacing: 16,
  nameFontSize: 'T200',
  nameFontWeight: 'medium',
  nameLineHeight: 1,
  textFontSize: 'T100',
  lineHeight: 1,
  spacing: 3,
  maxChildren: 2
}), (0, _defineProperty2.default)(_layoutConstants, _interfaces.AvatarSize.Large, {
  imageSize: 112,
  imageSpacing: 24,
  nameFontSize: 'T500',
  nameFontWeight: 'regular',
  nameLineHeight: 1,
  textFontSize: 'T300',
  lineHeight: 1,
  spacing: 12,
  maxChildren: 3
}), _layoutConstants);
exports.layoutConstants = layoutConstants;
var sharedPropTypes = {
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.AvatarColorScheme)).description('Sets a predefined color scheme to use for the component.')
};
exports.sharedPropTypes = sharedPropTypes;
var DEFAULT_COLOR_SCHEME = {
  textColor: 'neutral100',
  linkColor: 'primary70',
  pronounColor: 'neutral70'
};
exports.DEFAULT_COLOR_SCHEME = DEFAULT_COLOR_SCHEME;
var INVERTED_COLOR_SCHEME = {
  textColor: 'neutral0',
  linkColor: 'neutral0',
  pronounColor: 'neutral40'
};
exports.INVERTED_COLOR_SCHEME = INVERTED_COLOR_SCHEME;
var BADGE_PHOTO_URL = 'https://cdn.prod.badgephotos.side.amazon.dev/';
exports.BADGE_PHOTO_URL = BADGE_PHOTO_URL;
var PHONE_TOOL_URL = 'https://phonetool.amazon.com/users/';
exports.PHONE_TOOL_URL = PHONE_TOOL_URL;
var AvatarDefaultProps = {
  size: _interfaces.AvatarSize.Medium,
  showImage: true,
  isUsernameClickable: true,
  newTabHiddenText: 'opens in a new tab or new window',
  showUsername: true,
  colorScheme: _interfaces.AvatarColorScheme.Default,
  showFullName: true
};
exports.AvatarDefaultProps = AvatarDefaultProps;

var PersonalDetailsAvatarDefaultProps = _objectSpread(_objectSpread({}, AvatarDefaultProps), {}, {
  businessTitleHiddenText: 'business title',
  departmentHiddenText: 'department',
  locationHiddenText: 'location'
});

exports.PersonalDetailsAvatarDefaultProps = PersonalDetailsAvatarDefaultProps;